/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const sisterwood: CommunityData = {
  code: "sisterwood",
  name: "Sisterwood",
  inviteCode: "sisterwood",
  thumbnail: "/assets/customizations/sisterwood/sisterwood-thumbnail.png",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/sis-151`,
  socials: {
    instagramLink: "https://www.instagram.com/sisterwoodfestivalen/",
    soundcloudLink: "",
  },
  styles: {
    global: {
      counterColor: "#000000",
      alternativeLogo: {
        src: "/assets/customizations/sisterwood/logo-alt.png",
        styles: "w-[107px] object-contain",
      },
      logo: {
        src: "/assets/customizations/sisterwood/logo.png",
        styles: "w-[130px] h-[130px] object-contain",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#ECE1D3",
      asideStyles: "",
      asideBg: "#ffffff",
      contentBg: "#ffffff",
      contentBoxShadow: "shadow-[0px_4px_4px_rgba(0,0,0,0.25)]",
      bgDesktop: "",
      bgMobile: "",
      nonMemberBg: "",
      mainFont: "font-['Fournier']",
      primaryButton:
        "w-full sm:w-fit !h-[52px] bg-black !px-4 !text-[20px] !leading-[1] font-['HaasGrotesk'] font-medium !text-white whitespace-nowrap uppercase",
    },
    navigation: {
      sideBarSeparator: "border-r-[1px] border-black border-opacity-[15%]",
      iconsColor: "#000000",
      separator: "border-[#ECE1D3] border-t",
      item: "font-['HaasGrotesk'] font-medium text-[18px] leading-[18px] h-[40px] flex sm:justify-start justify-center items-center uppercase text-black !pt-1",
      itemSelected: "bg-[#FAF4EC] text-[#000000]",
    },
    communityLanding: {
      emptyOrLoadingState: "",
      titles: "font-['HaasGrotesk'] font-medium text-black text-[24px] leading-6",
      announcements: {
        customBg: "bg-[#E30000]",
        lg: {
          title: "text-base sm:text-[24px] leading-[1] font-medium font-['HaasGrotesk'] mb-1",
          subtitle: "text-[13px] leading-[1] !text-white pb-[2px]",
        },
        sm: {
          title: "text-base sm:text-[16px] leading-[1] font-medium font-['HaasGrotesk'] mb-2",
          subtitle: "text-[13px] leading-[1] !text-white pb-[2px]",
        },
      },
      event: {
        title: "text-[16px] font-medium leading-5 text-black font-['HaasGrotesk']",
        subtitle: "text-[18px] leading-6 text-black",
      },
      shop: {
        title:
          "text-black font-['HaasGrotesk'] font-medium uppercase text-black text-[20px] leading-5",
        text: "text-[18px] leading-6 text-black",
        customShopImage: "/assets/customizations/sisterwood/img_shop.png",
      },
    },
    announcements: {
      emptyOrLoadingState: "",
      created: "",
      container: "mb-16 p-11 pb-8 space-y-[57px]",
      header: "font-['HaasGrotesk'] font-medium text-black text-[32px] leading-[32px]",
      title: "font-['HaasGrotesk'] font-medium text-black text-[24px] leading-6",
      description: "text-[13px] leading-[1] !text-white pb-[2px]",
    },
    announcement: {
      likeCount: "",
      commentCount: "",
      emptyOrLoadingState: "",
      created: "",
      container: "mb-16 p-11 pb-8 space-y-[23px]",
      title: "font-['HaasGrotesk'] font-medium text-black text-[24px] leading-6",
      description: "text-[13px] leading-[1] !text-white pb-[2px]",
      commentIconColor: "",
      likeIconColor: "",
    },
    event: {
      emptyOrLoadingState: "",
      sectionTitle: "font-['HaasGrotesk'] font-medium uppercase text-black text-[28px] leading-8",
      sectionSubtitle: "text-[18px] leading-[24px] text-black",
      text: "text-[18px] leading-[24px] text-black",
      separator: "border-b border-black",
      blockContainer: "",
      header: "",
      container: "",
      map: {
        pin: "",
        border: "",
        pinColor: "#EF040D",
        strokeColor: "",
      },
    },
    eventTickets: {
      container: "",
      separator: "",
      event: {
        title: "font-['HaasGrotesk'] font-medium text-black text-[28px] leading-8",
        subtitle: "text-[18px] leading-[24px] text-black",
      },
      ticket: {
        counterContainer: "",
        title: "text-[24px] leading-6 font-['HaasGrotesk'] font-medium text-black uppercase",
        description: "text-[16px] leading-[16px] text-black",
        text: "text-[18px] leading-[24px] text-black",
        price: "text-[24px] leading-6 font-['HaasGrotesk'] font-medium text-black",
        quantity: "text-[20px] leading-5 font-['HaasGrotesk'] font-medium text-black",
      },
    },
  },
}

export default sisterwood
